import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import { Footer } from "./Components/Footer/Footer";

import { useEffect } from "react";
import About from "./Pages/About";
import AfterMarket from "./Pages/AfterMarket";
import Career from "./Pages/Career";
import CaP from "./Pages/Chassis";
import Contact from "./Pages/Contact";
import Customers from "./Pages/Customers";
import Energy from "./Pages/Energy";
import EnvAndEnergy from "./Pages/EnvAndEnergy";
import Enviromental from "./Pages/Environmental";
import GreenPurchase from "./Pages/GreenPurchase";
import Health from "./Pages/Health";
import History from "./Pages/History";
import Home from "./Pages/Home";
import IndustrialDesign from "./Pages/IndustrialDesign";
import InformationCommunity from "./Pages/InformationCommunity";
import ISO from "./Pages/ISO";
import ModernSlaveryPolicy from "./Pages/ModernSlavery";
import New from "./Pages/NewPage";
import News from "./Pages/News";
import OEM from "./Pages/OEM";
import Production from "./Pages/Production";
import Products from "./Pages/Products";
import Protection from "./Pages/Protection";
import QR from "./Pages/QR";
import Quality from "./Pages/Quality";
import RND from "./Pages/RND";
import Security from "./Pages/Security";
import SocialCompliance from "./Pages/SocialComplience";
import Social from "./Pages/SocialResponsibility";
import { StudentProgram } from "./Pages/StudentPrograms/StudentPrograms";
import SupplierSustainability from "./Pages/SupplierSustaninability";
import SustainabilityReport from "./Pages/SustainabilityReport";
import StakeholderEngagementPlan from "./Pages/StakeholderEngagementPlan";
import Values from "./Pages/Values";
import Climate from "./Pages/Climate";
import TempPrivacy from "./Pages/TempPrivacy";
import NewPublicOfferInfo from "./Pages/PublicOfferInfo";
import OldPublicOfferInfo from "./Pages/OldPublicOffer/OldPublicOfferInfo";
import AnalystReports from "./Pages/PublicOfferInfo/analystReports";
import BoardMembers from "./Pages/Board/BoardMembers";
import CommitteesPage from "./Pages/Board/CommitteesPage";
import TradeRegistryPage from "./Pages/Board/TradeRegistryPage";
import GeneralAssembly from "./Pages/Board/GeneralAssembly";
import CorporateGovernanceReport from "./Pages/Board/CorporateGovernanceReport";
import ArticlesOfAssociation from "./Pages/Board/ArticlesOfAssociation";
import CapitalStructure from "./Pages/Board/CapitalStructure";
import PoliciesPage from "./Pages/Board/PoliciesPage";
import SeniorManagement from "./Pages/Board/SeniorManagement";
import FinancialResults from "./Pages/FinancialResults/FinancialResults";
import InvestorPresentations from "./Pages/InvestorPresentations/InvestorPresentations";
import Reports from "./Pages/Reports/Reports";
import FaqPage from "./Pages/Faq/FaqPage";
import AnnouncementDetail from "./Pages/Announcements/AnnouncementsDetail";
import SpecialAnnouncements from "./Pages/Announcements/SpecialAnnouncements";
import PressAnnouncements from "./Pages/Announcements/PressAnnouncements";
import ExecutiveCommitee from "./Pages/Board/ExecutiveCommitee";
import TempPrivacyWorkloy from "./Pages/WorkloyPrivacy";
import Founder from "./Pages/Founder";



function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/corporate/about" element={<About />} />
        <Route path="/:lang/kurumsal/hakkimizda" element={<About />} />
        <Route path="/corporate/our-founder-huseyin-ozyavuz" element={<Founder />} />
        <Route path="/:lang/kurumsal/kurucumuz-huseyin-ozyavuz" element={<Founder />} />
        <Route path="/corporate/history" element={<History />} />
        <Route path="/:lang/kurumsal/tarihce" element={<History />} />
        <Route path="/corporate/clients" element={<Customers />} />
        <Route path="/:lang/kurumsal/musterilerimiz" element={<Customers />} />
        <Route path="/corporate/values" element={<Values />} />
        <Route path="/:lang/kurumsal/degerlerimiz" element={<Values />} />
        <Route path="/corporate/information-community-system" element={<InformationCommunity />} />
        <Route path="/:lang/kurumsal/bilgi-toplum-sistemi" element={<InformationCommunity />} />
        <Route path="/corporate/:link" element={<New />} />
        <Route path="/:lang/kurumsal/:link" element={<New />} />
        <Route path="/products" element={<Products />} />
        <Route path="/:lang/urunler" element={<Products />} />
        <Route path="/products/oem" element={<OEM />} />
        <Route path="/:lang/urunler/oem" element={<OEM />} />
        <Route path="/products/social-responsibility" element={<Social />} />
        <Route path="/:lang/urunler/sosyal-sorumluluk" element={<Social />} />
        <Route path="/products/after-market" element={<AfterMarket />} />
        <Route path="/:lang/urunler/after-market" element={<AfterMarket />} />
        <Route path="/products/chassis-and-powertrain" element={<CaP />} />
        <Route path="/:lang/urunler/sasi-ve-powertrain" element={<CaP />} />
        <Route path="/products/:link" element={<New />} />
        <Route path="/:lang/urunler/:link" element={<New />} />
        <Route
          path="/development-and-production/rnd-engineering"
          element={<RND />}
        />
        <Route
          path="/:lang/gelistirme-ve-uretim/arge-ve-muhendislik"
          element={<RND />}
        />
        <Route
          path="/development-and-production/quality"
          element={<Quality />}
        />
        <Route
          path="/:lang/gelistirme-ve-uretim/kalite"
          element={<Quality />}
        />
        <Route
          path="/development-and-production/production"
          element={<Production />}
        />
        <Route
          path="/:lang/gelistirme-ve-uretim/uretim"
          element={<Production />}
        />
        <Route path="/development-and-production/:link" element={<New />} />
        <Route path="/:lang/gelistirme-ve-uretim/:link" element={<New />} />
        <Route path="/industrial-design" element={<IndustrialDesign />} />
        <Route path="/:lang/endustriyel-tasarim" element={<IndustrialDesign />} />
        <Route
          path="/sustainability/environment-and-energy-policy"
          element={<EnvAndEnergy />}
        />
        <Route
          path="/:lang/surdurulebilirlik/cevre-ve-enerji-politikasi"
          element={<EnvAndEnergy />}
        />
        <Route
          path="/sustainability/environmental-policy-and-activities"
          element={<Enviromental />}
        />
        <Route
          path="/:lang/surdurulebilirlik/cevre-politikasi-ve-aktiviteleri"
          element={<Enviromental />}
        />
        <Route
          path="/sustainability/climate-change-policy"
          element={<Climate />}
        />
        <Route
          path="/:lang/surdurulebilirlik/iklim-degisikligi-politikasi"
          element={<Climate />}
        />
        <Route path="/sustainability/iso-14001-2015-scope" element={<ISO />} />
        <Route path="/:lang/surdurulebilirlik/iso-14001-2015-kapsami" element={<ISO />} />
        <Route
          path="/sustainability/energy-management-policy"
          element={<Energy />}
        />
        <Route
          path="/:lang/surdurulebilirlik/enerji-yonetimi-politikasi"
          element={<Energy />}
        />
        <Route
          path="/sustainability/green-purchasing"
          element={<GreenPurchase />}
        />
        <Route
          path="/:lang/surdurulebilirlik/yesil-satin-alma"
          element={<GreenPurchase />}
        />
        <Route
          path="/sustainability/occupational-health-and-safety-policy-and-activities"
          element={<Health />}
        />
        <Route
          path="/:lang/surdurulebilirlik/is-sagligi-ve-guvenligi-politikasi-ve-aktiviteleri"
          element={<Health />}
        />
        <Route
          path="/sustainability/social-compliance-policy"
          element={<SocialCompliance />}
        />
        <Route
          path="/:lang/surdurulebilirlik/sosyal-uygunluk-politikasi"
          element={<SocialCompliance />}
        />
        <Route
          path="/sustainability/modern-slavery-policy"
          element={<ModernSlaveryPolicy />}
        />
        <Route
          path="/:lang/surdurulebilirlik/modern-kolelik-politikasi"
          element={<ModernSlaveryPolicy />}
        />
        <Route
          path="/sustainability/information-security-policy"
          element={<Security />}
        />
        <Route
          path="/:lang/surdurulebilirlik/bilgi-guvenligi-politikasi"
          element={<Security />}
        />
        <Route
          path="/sustainability/protection-of-personal-data"
          element={<Protection />}
        />
        <Route
          path="/:lang/surdurulebilirlik/kisisel-verilerin-korunmasi"
          element={<Protection />}
        />
        <Route
          path="/sustainability/privacy-policy/trafik"
          element={<TempPrivacy />}
        />
        <Route
          path="/sustainability/privacy-policy/workloy"
          element={<TempPrivacyWorkloy />}
        />
        <Route
          path="/sustainability/stakeholder-engagement-plan"
          element={<StakeholderEngagementPlan />}
        />
        <Route
          path="/:lang/surdurulebilirlik/paydas-katilim-plani"
          element={<StakeholderEngagementPlan />}
        />
        <Route
          path="/sustainability/sustainability-report"
          element={<SustainabilityReport />}
        />
        <Route
          path="/:lang/surdurulebilirlik/surdurulebilirlik-raporu"
          element={<SustainabilityReport />}
        />
        <Route path="/sustainability/supplier-sustainability-policy" element={<SupplierSustainability />} />
        <Route path="/:lang/surdurulebilirlik/tedarikci-surdurulebilirlik-politikasi" element={<SupplierSustainability />} />
        <Route path="/sustainability/:link" element={<New />} />
        <Route path="/:lang/surdurulebilirlik/:link" element={<New />} />
        <Route path="/career" element={<Career />} />
        <Route path="/:lang/kariyer" element={<Career />} />
        <Route path="/student-programs" element={<StudentProgram />} />
        <Route path="/:lang/ogrenci-programlari" element={<StudentProgram />} />
        <Route path="/news" element={<News />} />
        <Route path="/:lang/haberler" element={<News />} />
        <Route path="investor-relations/initial-public-offering-new" element={<NewPublicOfferInfo />} />
        <Route path="/:lang/yatirimci-iliskileri/halka-arz-yeni" element={<NewPublicOfferInfo />} />
        <Route path="investor-relations/initial-public-offering" element={<OldPublicOfferInfo />} />
        <Route path="/:lang/yatirimci-iliskileri/halka-arz" element={<OldPublicOfferInfo />} />
        <Route path="investor-relations/analyst-reports" element={<AnalystReports />} />
        <Route path="/:lang/yatirimci-iliskileri/analist-raporlari" element={<AnalystReports />} />
        <Route path="investor-relations/board-of-directors" element={<BoardMembers />} />
        <Route path="/:lang/yatirimci-iliskileri/yonetim-kurulu" element={<BoardMembers />} />
        <Route path="investor-relations/executive-committee" element={<ExecutiveCommitee />} />
        <Route path="/:lang/yatirimci-iliskileri/icra-kurulu" element={<ExecutiveCommitee />} />
        <Route path="investor-relations/board-committees" element={<CommitteesPage />} />
        <Route path="/:lang/yatirimci-iliskileri/yonetim-kurulu-komiteleri" element={<CommitteesPage />} />
        <Route path="investor-relations/trade-registry" element={<TradeRegistryPage />} />
        <Route path="/:lang/yatirimci-iliskileri/ticaret-sicili" element={<TradeRegistryPage />} />
        <Route path="investor-relations/general-assembly" element={<GeneralAssembly />} />
        <Route path="/:lang/yatirimci-iliskileri/genel-kurul" element={<GeneralAssembly />} />
        <Route path="investor-relations/corporate-governance-report" element={<CorporateGovernanceReport />} />
        <Route path="/:lang/yatirimci-iliskileri/kurumsal-yonetim-raporu" element={<CorporateGovernanceReport />} />
        <Route path="investor-relations/articles-of-association" element={<ArticlesOfAssociation />} />
        <Route path="/:lang/yatirimci-iliskileri/esas-sozlesme" element={<ArticlesOfAssociation />} />
        <Route path="investor-relations/capital-structure" element={<CapitalStructure />} />
        <Route path="/:lang/yatirimci-iliskileri/sermaye-yapisi" element={<CapitalStructure />} />
        <Route path="investor-relations/policies" element={<PoliciesPage />} />
        <Route path="/:lang/yatirimci-iliskileri/politikalar" element={<PoliciesPage />} />
        {/* <Route path="investor-relations/senior-management" element={<SeniorManagement />} />
        <Route path="/:lang/yatirimci-iliskileri/ust-yonetim" element={<SeniorManagement />} /> */}
        <Route path="investor-relations/financial-results" element={<FinancialResults />} />
        <Route path="/:lang/yatirimci-iliskileri/finansal-sonuclar" element={<FinancialResults />} />
        <Route path="investor-relations/investor-presentations" element={<InvestorPresentations />} />
        <Route path="/:lang/yatirimci-iliskileri/yatirimci-sunumlari" element={<InvestorPresentations />} />
        <Route path="investor-relations/reports" element={<Reports />} />
        <Route path="/:lang/yatirimci-iliskileri/raporlar" element={<Reports />} />
        <Route path="investor-relations/faq" element={<FaqPage />} />
        <Route path="/:lang/yatirimci-iliskileri/sikca-sorulan-sorular" element={<FaqPage />} />
        <Route path="investor-relations/special-announcements" element={<SpecialAnnouncements />} />
        <Route path="/:lang/yatirimci-iliskileri/ozel-durum-aciklamalari" element={<SpecialAnnouncements />} />

        <Route path="investor-relations/press-announcements" element={<PressAnnouncements />} />
        <Route path="/:lang/yatirimci-iliskileri/basin-duyurulari" element={<PressAnnouncements />} />

        <Route path="/announcements/:link" element={<AnnouncementDetail />} />
        <Route path="/:lang/duyurular/:link" element={<AnnouncementDetail />} />



        <Route path="/investor-relations/:link" element={<New />} />
        <Route path="/:lang/yatirimci-iliskileri/:link" element={<New />} />

        <Route path="/:link" element={<New />} />
        <Route path="/:lang/:link" element={<New />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/:lang/iletisim" element={<Contact />} />
        <Route path="/qr" element={<QR />} />
        <Route
          path="*"
          element={<Navigate to="/" />}
          component={<div>404</div>}
        />

      </Routes>
      <Footer />
    </>
  );
}

// export const App_TR = () => {
//   return (
//     <>
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/corporate/about" element={<About />} />
//         <Route path="/corporate/history" element={<History />} />
//         <Route path="/corporate/clients" element={<Customers />} />
//         <Route path="/corporate/values" element={<Values />} />
//         <Route path="/corporate/information-community-system" element={<InformationCommunity />} />
//         <Route path="/products" element={<Products />} />
//         <Route path="/products/oem" element={<OEM />} />
//         <Route path="/products/social-responsibility" element={<Social />} />
//         <Route path="/products/after-market" element={<AfterMarket />} />
//         <Route path="/products/chassis-and-powertrain" element={<CaP />} />
//         <Route
//           path="/development-and-production/rnd-engineering"
//           element={<RND />}
//         />
//         <Route
//           path="/development-and-production/quality"
//           element={<Quality />}
//         />
//         <Route
//           path="/development-and-production/production"
//           element={<Production />}
//         />
//         <Route path="/industrial-design" element={<IndustrialDesign />} />
//         <Route
//           path="/sustainability/environmental-policy-and-activities"
//           element={<Enviromental />}
//         />
//         <Route path="/sustainability/iso-14001-2015-scope" element={<ISO />} />
//         <Route
//           path="/sustainability/energy-management-policy"
//           element={<Energy />}
//         />
//         <Route
//           path="/sustainability/occupational-health-and-safety-policy-and-activities"
//           element={<Health />}
//         />
//         <Route
//           path="/sustainability/information-security-policy"
//           element={<Security />}
//         />
//         <Route
//           path="/sustainability/protection-of-personal-data"
//           element={<Protection />}
//         />
//         <Route
//           path="/sustainability/sustainability-report"
//           element={<SustainabilityReport />}
//         />
//         <Route path="/career" element={<Career />} />
//         <Route path="/news" element={<News />} />
//         <Route path="investor-relations/initial-public-offering" element={<PublicOfferInfo />} />
//         <Route path="/:link" element={<New />} />
//         <Route path="/iletisim" element={<Contact />} />
//         <Route
//           path="*"
//           element={<Navigate to="/" />}
//           component={<div>404</div>}
//         />
//       </Routes>
//       <Footer />
//     </>
//   );
// };

export default App;
